import Icon from "@ant-design/icons"
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon"
import React from "react"
import { AntIconType } from "../antIcon.types"

const addDatevLogo = (props: CustomIconComponentProps) => (
    <svg width={props.width} height={props.height} viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect fill="white" />
        <path d="M27.5481 14L29.4931 19.5098H29.5698L31.5111 14H33L30.3653 21H28.694L26.0629 14H27.5481Z" fill="black" />
        <path d="M20.8201 21V14H25.6808V15.063H22.174V16.9634H25.429V18.0264H22.174V19.937H25.71V21H20.8201Z" fill="black" />
        <path d="M14.2217 15.063V14H20.1844V15.063H17.8745V21H16.5316V15.063H14.2217Z" fill="black" />
        <path d="M9.4907 21H8.04562L10.6767 14H12.348L14.9827 21H13.5376L11.5415 15.4355H11.4832L9.4907 21ZM9.53814 18.2554H13.4793V19.2739H9.53814V18.2554Z" fill="black" />
        <path
            d="M4.53253 21H2V14H4.58362C5.32562 14 5.96301 14.1401 6.49579 14.4204C7.03101 14.6984 7.44215 15.0983 7.72922 15.6201C8.01628 16.1419 8.15982 16.7663 8.15982 17.4932C8.15982 18.2223 8.01507 18.849 7.72557 19.373C7.4385 19.8971 7.02371 20.2993 6.4812 20.5796C5.94112 20.8599 5.29156 21 4.53253 21ZM3.35385 19.9028H4.46685C4.98746 19.9028 5.42172 19.814 5.7696 19.6362C6.11749 19.4562 6.37902 19.1885 6.55418 18.833C6.72934 18.4753 6.81692 18.0286 6.81692 17.4932C6.81692 16.9577 6.72934 16.5133 6.55418 16.1602C6.37902 15.8047 6.11993 15.5392 5.7769 15.3638C5.43631 15.186 5.01301 15.0972 4.50699 15.0972H3.35385V19.9028Z"
            fill="black"
        />
    </svg>
)

export const DatevLogo = (props: AntIconType) => <Icon component={addDatevLogo} {...props} />
